var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepActive3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_2070)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#CB90FC",
    stroke: "#45185A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3354 20.656C14.8067 20.656 14.304 20.5607 13.8274 20.37C13.3594 20.1707 12.9564 19.8933 12.6184 19.538C12.289 19.174 12.0637 18.745 11.9424 18.251L13.4894 17.705C13.6454 18.147 13.8837 18.485 14.2044 18.719C14.525 18.9443 14.902 19.057 15.3354 19.057C15.682 19.057 15.981 18.992 16.2324 18.862C16.4924 18.732 16.696 18.5457 16.8434 18.303C16.9907 18.0517 17.0644 17.757 17.0644 17.419C17.0644 17.081 16.9907 16.795 16.8434 16.561C16.7047 16.3183 16.5054 16.132 16.2454 16.002C15.9854 15.872 15.6777 15.807 15.3224 15.807C15.1577 15.807 14.9844 15.8243 14.8024 15.859C14.629 15.8937 14.473 15.9457 14.3344 16.015L13.9314 15.17L16.4404 12.31H12.4884V10.815H18.4294V12.206L15.9074 15.157L15.9334 14.494C16.514 14.5027 17.021 14.6283 17.4544 14.871C17.8877 15.1137 18.2257 15.4473 18.4684 15.872C18.711 16.2967 18.8324 16.795 18.8324 17.367C18.8324 17.991 18.6807 18.5543 18.3774 19.057C18.074 19.551 17.658 19.941 17.1294 20.227C16.6007 20.513 16.0027 20.656 15.3354 20.656Z",
    fill: "#45185A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepActive3);
export default __webpack_public_path__ + "static/media/StepActive3.ce8d1b845c22d3647bdfe6d08d19ee22.svg";
export { ForwardRef as ReactComponent };